<template>
  <div class="modal-card"
       style="width: 500px">
    <header class="modal-card-head is-small">
      <p class="modal-card-title"
         style="text-align: center;">ベースプライス更新</p>
      <span class="v-icon-close"
            style="cursor: pointer;"
            @click="$emit('close')">
        <b-icon size="is-medium"
                pack="fa"
                icon="window-close"> </b-icon>
      </span>
    </header>
    <section class="modal-card-body v-custorm-body">
      <div class="group-column">
        <div class="field">
          <p class="field-label">最安値</p>
          <p class="field-value">{{ (item.dataFee.basePriceFee.setting_fee_company) | formatNumber }}</p>
        </div>
      </div>
      <div class="group-column">
        <div class="field">
          <p class="field-label">ベースプライス</p>
          <p class="field-value">{{ (item.dataFee.basePriceFee.setting_fee | formatNumber) }}</p>
        </div>
      </div>

      <div class="group-column">
        <div class="field">
          <p class="field-label">変更金額</p>
          <b-input class="input-setting-fee"
                   v-model="setting_fee_new" />
        </div>
        <span style="color: red; font-size: 15;">{{ msgSettingFee }}</span>
      </div>

      <div class="group-column">
        <b-button class="field field-button"
                  label="更新"
                  @click="updateCompanyFee();" />


      </div>
    </section>
  </div>
</template>

<script>
import jcPackage from '@/repositories/jcPackage';
const regexFormatNumber = /^[0-9]+$/;
const regexEmppty = /^$/;
export default {
  props: [
    'item', 'token'
  ],
  data: () => ({
    setting_fee_new: '',
    errSettingFee: '',
    msgSettingFee: ''
  }),
  computed: {

  },
  methods: {
    updateCompanyFee() {

      if (regexEmppty.test(this.setting_fee_new)) {
        this.errSettingFee = 'is-danger';
        this.msgSettingFee = '変更金額を入力してください。';
        return;
      } else {
        if (regexFormatNumber.test(this.setting_fee_new)) {
          this.errSettingFee = '';
          this.msgSettingFee = '';
        } else {
          this.errSettingFee = 'is-danger';
          this.msgSettingFee = '数字のみ入力してください。';
          return;
        }
      }
      if (this.setting_fee_new < this.item.dataFee.basePriceFee.setting_fee_company) {
        this.errSettingFee = 'is-danger';
        this.msgSettingFee = '最安値金額とベース金額が逆転しております。確認の上、更新してください。';
        return;
      }
      this.$buefy.dialog.confirm({
        message: "これから作成されるこのルートの請求金額全てに影響が出ます。保存しますか？",
        confirmText: "Yes",
        cancelText: "No",
        confirmOptions: {
          type: "is-success",
          outlined: true,
        },
        cancelOptions: {
          type: "is-danger",
          outlined: true,
        },
        onConfirm: () => {
          const params = {
            setting_fee_id: this.item.dataFee.basePriceFee.setting_fee_id,
            setting_fee: this.setting_fee_new,
            auction_place_id: this.item.placeId,
            from_satellite_id: this.item.satelliteId,
            yard_record_id: this.item.yardId,
            inland_company_id: this.item.dataFee.basePriceFee.inland_company_id,
            place_yard_type: this.item.isSearchAuction
          };
          jcPackage
            .updateFeeBase(
              this.token,
              params
            )
            .then((rs) => {
              this.item.dataFee.basePriceFee.setting_fee = this.setting_fee_new;
              this.$emit('close');
            })
            .catch((err) => {
              console.log('updateFeeBase', err);
            });
        },
        onCancel: () => {
          return;
        },
        customClass: "custom-dialog-buttons",
      });



    }
  },
};
</script>

<style>
.group-column {
  width: 80%;
  margin: auto;
  padding: 0.5rem 0.75rem !important;
  display: block;
}

.group-column .field {
  width: 100%;
  border: 1px solid #b5b5b5;
  border-radius: 6px;
}

.group-column .field p {
  width: 100%;
  height: 35px;
  line-height: 2;
  text-align: center;
}

.field-value {
  border-top: 1px solid #b5b5b5;
  background-color: #d7d7d7;
}

.group-field {
  display: flex;
  gap: 5%;
}

.field-child {
  width: 50%;
  margin-bottom: 0;
  border: 1px solid #b5b5b5;
  border-radius: 6px;
}

.field-child p {
  width: 100%;
  height: 35px;
  line-height: 2;
  text-align: center;
}

.input-setting-fee input {
  border: none;
  border-top: 1px solid #b5b5b5;
  border-radius: 0;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  box-shadow: none;
  text-align: center;
}

.field-label {
  font-weight: 600;
}

.field-button {
  width: 25% !important;
  margin-left: 40%;
}

.buefy-dialog button.button {
  margin: 0 5px;
}

.dialog .modal-card .modal-card-foot{
  display: flex !important;
  justify-content: space-around !important;
}
</style>
